import { DeliveryEmailInput } from '@features/delivery/components/DeliveryEmailInput';
import { DeliveryModal } from '@features/delivery/components/DeliveryModal';
import { useDeliveryContext } from '@features/delivery/components/DeliveryModal/DeliveryContext';
import { Flex, Text, TextField } from '@radix-ui/themes';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SendDeliveryItem, SendPayload } from '../types';

export const SendDialog = () => {
    const { t } = useTranslation('send');

    const { suggestedEmails, executeAction, isOpen } = useDeliveryContext<
        SendDeliveryItem,
        SendPayload
    >();

    const [subject, setSubject] = useState('');
    const [recipients, setRecipients] = useState<string[]>([]);
    const [ccEmails, setCcEmails] = useState<string[]>([]);

    useEffect(() => {
        if (!isOpen) {
            setSubject('');
            setRecipients([]);
            setCcEmails([]);
        }
    }, [isOpen]);

    const isFormValid = recipients.length > 0 && subject.trim().length > 0;

    return (
        <DeliveryModal.Content<SendDeliveryItem, SendPayload>
            title={t('title')}
            a11yDescription={t('a11yDescription')}
            successTitle={t('success.title')}
            successDescription={t('success.desc')}
        >
            <Flex direction='column' gap='1'>
                <Text size='2' weight='bold'>
                    {t('inputs.subject')}
                </Text>
                <TextField.Root
                    size='3'
                    placeholder={t('inputs.subjectPlaceholder')}
                    value={subject}
                    onChange={(e) => setSubject(e.target.value)}
                />
            </Flex>

            <Flex direction='column' gap='1'>
                <Text size='2' weight='bold'>
                    {t('inputs.recipients')}
                </Text>
                <DeliveryEmailInput
                    emails={recipients}
                    onEmailsChange={setRecipients}
                    placeholder={t('inputs.recipientsPlaceholder')}
                    suggestedEmails={suggestedEmails}
                />
            </Flex>

            <Flex direction='column' gap='1'>
                <Text size='2' weight='bold'>
                    {t('inputs.cc')}
                </Text>
                <DeliveryEmailInput
                    emails={ccEmails}
                    onEmailsChange={setCcEmails}
                    placeholder={t('inputs.ccPlaceholder')}
                    suggestedEmails={suggestedEmails}
                />
            </Flex>

            <DeliveryModal.ItemList<SendDeliveryItem, SendPayload>
                label={t('inputs.items')}
            />

            <DeliveryModal.ActionSubmit<SendDeliveryItem, SendPayload>
                label={t('actions.send')}
                processingLabel={t('actions.processing')}
                disabled={!isFormValid}
                onClick={() => executeAction({ subject, recipients, ccEmails })}
            />
        </DeliveryModal.Content>
    );
};
